import React, { Component } from 'react';
import { Modal } from 'antd';
import { UserContext } from '../UserContext';
import { withRouter } from '../utils/withRouter';
import api from '../api/index';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import LoadingComponent from './LoadingComponent';
class ChangePassword extends Component {
  static contextType = UserContext;

  state = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
    passwordsMatch: true,
    isLoading: false,
    showOldPassword: false,
    showNewPassword: false,
    showConfirmPassword: false,
  };

  handlePasswordChange = (e) => {
    this.setState({ [e.target.name]: e.target.value }, this.checkPasswordsMatch);
  };

  checkPasswordsMatch = () => {
    const { newPassword, confirmPassword } = this.state;
    if (confirmPassword) {
      this.setState({ passwordsMatch: newPassword === confirmPassword });
    }
  };

  savePasswordChange = async () => {
    const { oldPassword, newPassword, confirmPassword, passwordsMatch } = this.state;
    const access_token = this.context.user.access_token;

    if (!oldPassword || !newPassword || !confirmPassword) {
      return Modal.error({ title: 'Error', content: 'Please fill in all fields.' });
    }

    if (!passwordsMatch) {
      return Modal.error({ title: 'Error', content: 'Passwords do not match.' });
    }

    if (newPassword.length < 8) {
      return Modal.error({ title: 'Error', content: 'Password must be at least 8 characters.' });
    }

    this.setState({ isLoading: true });

    try {
      const response = await fetch(`${api.main}/api/auth/change_password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: this.context.user.id,
          old_password: oldPassword,
          password: newPassword,
          access_token: access_token,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || data.message || 'Failed to update password.');
      }

      // Password updated successfully
      this.setState({ oldPassword: '', newPassword: '', confirmPassword: '' });

      // Handle successful update
      if (data.status === 104 || data.requireRelogin) {
        this.showRedirectModal();
      } else {
        Modal.success({
          title: 'Success',
          content: 'Password updated successfully.',
        });
      }
    } catch (err) {
      Modal.error({
        title: 'Error',
        content: err.message || 'Something went wrong while updating your password.',
      });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  showRedirectModal = () => {
    let countdown = 5;

    // Log the user out from context
    this.context.setUser(null);

    const modal = Modal.info({
      title: 'Password Updated Successfully',
      content: `You will be redirected to the login page in ${countdown} seconds.`,
      centered: true,
      okButtonProps: { style: { display: 'none' } },
    });

    const countdownInterval = setInterval(() => {
      countdown--;
      modal.update({ content: `You will be redirected to the login page in ${countdown} seconds.` });

      if (countdown === 0) {
        clearInterval(countdownInterval);
        modal.destroy();
        this.props.navigate('/');
      }
    }, 1000);
  };

  render() {
    const { oldPassword, newPassword, confirmPassword, passwordsMatch, isLoading, showOldPassword, showNewPassword, showConfirmPassword } = this.state;

    if(isLoading) {
      return <LoadingComponent />
    }

    return (
      <div>
        <div className="account-settings">
          <h2>Change Password</h2>
          <div className="account-section">
            <div className="account-item">
              <div className="password-wrapper">
                <input
                  type={showOldPassword ? "text" : "password"}
                  name="oldPassword"
                  className="password-input"
                  placeholder="Old Password"
                  value={oldPassword}
                  onChange={this.handlePasswordChange}
                  disabled={isLoading}
                  onKeyDown={(e) => {
                    if (e.key === " ") e.preventDefault();
                    }}
                  required
                />
                <FontAwesomeIcon
                  icon={showOldPassword ? faEyeSlash : faEye}
                  className="toggle-visibility"
                  onClick={() => this.setState({ showOldPassword: !showOldPassword })}
                />
              </div>
            </div>
          </div>
          <div className="account-section">
            <div className="account-item">
              <div className="password-wrapper">
                <input
                  type={showNewPassword ? "text" : "password"}
                  name="newPassword"
                  className="password-input"
                  placeholder="New Password"
                  value={newPassword}
                  onChange={this.handlePasswordChange}
                  disabled={isLoading}
                  onKeyDown={(e) => {
                    if (e.key === " ") e.preventDefault();
                    }}
                  required
                />
                <FontAwesomeIcon
                  icon={showNewPassword ? faEyeSlash : faEye}
                  className="toggle-visibility"
                  onClick={() => this.setState({ showNewPassword: !showNewPassword })}
                />
              </div>
              {newPassword && newPassword.length < 8 && (
                <small className="text-warning">Password must be at least 8 characters</small>
              )}
            </div>
          </div>
          <div className="account-section">
            <div className="account-item">
              <div className="password-wrapper">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  className="password-input"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={this.handlePasswordChange}
                  disabled={isLoading}
                  onKeyDown={(e) => {
                    if (e.key === " ") e.preventDefault();
                    }}
                  required
                />
                <FontAwesomeIcon
                  icon={showConfirmPassword ? faEyeSlash : faEye}
                  className="toggle-visibility"
                  onClick={() => this.setState({ showConfirmPassword: !showConfirmPassword })}
                />
              </div>
              {confirmPassword && !passwordsMatch && (
                <small className="text-warning">Passwords do not match</small>
              )}
              {confirmPassword && passwordsMatch && confirmPassword.length > 0 && (
                <small className="text-success">Passwords match</small>
              )}
            </div>
          </div>
          <div className="account-section">
            <div className="account-item" style={{justifyContent: "space-evenly", flexDirection: "row-reverse"}}>
              <button
                className="btn btn-primary"
                style={{width:"200px"}}
                onClick={this.savePasswordChange}
                disabled={isLoading}
              >
                {isLoading ? 'Updating...' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ChangePassword);
